import { getWindow } from 'ssr-window';
let browser;

function calcBrowser() {
  const window = getWindow();

  function isSafari() {
    const ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
  }

  return {
    isSafari: isSafari(),
    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
  };
}

function getBrowser() {
  if (!browser) {
    browser = calcBrowser();
  }

  return browser;
}

export { getBrowser };


//////////////////
// WEBPACK FOOTER
// /Users/maxime/dev/heinrich-boch/web/app/themes/heinrich-bock/node_modules/swiper/shared/get-browser.js
// module id = 30
// module chunks = 0